import Tree from "@widgetjs/tree";
import { InputComponent, ValueComponentDefinition } from "components/components/Component";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import i18n from "components/i18n/i18n";
import { FieldOptions, isOptgroup, isOption, Optgroup, Option } from "components/input/select/options";

export class TreeInput implements InputComponent {

    public readonly componentType: string = "tree";

    public readonly id: string;
    public definition: TreeDefinition;
    public view: HTMLDivElement;

    private treeData: TreeData[] = [];
    private data: any[];
    private tree: any;

    constructor(definition: TreeDefinition) {
        this.definition = definition;
    }

    public getValue() {
        //Evitar excepcion para cndo se crea el obj tree con la funcion 'onChange'
        //, ya que la fnc this.getValue() falla al recuperar el values q todavia no 
        // esta creado. De ahi el ?
        return this.tree?.values;
    }

    public value(data: any[]): void {
        this.data = data;
    }

    private generateId = () => {
        return "_" + Math.random().toString(36).substr(2, 9);
    }

    public render(): Element {
        const div = document.createElement("div");
        div.innerHTML = "Tree";
        div.id = this.generateId();
        this.view = div;
        return div;
    }

    public postRender() {
        this.addOptions(this.definition.options);
        this.tree = new Tree("#" + this.view.id, {
            data: this.treeData,
            values: this.data,
            closeDepth: this.definition.closeDepth,
        });
        //Must add after create tree the function onChange
        //because there is interference with the fwk onchage 
        // event when the tree is created. This avoids the problem 
        Object.assign(this.tree.options, {
            onChange: () => {
                fireDataChangedEvent(this, this.view, this.getValue());
            }
        });

        /* This was implmented for desactivate by restrictions. But we don´t have access to restricctions bundles,
        * So we have to desactivate by option in Java code 
        * let disabledOptions = this.getAllOptions();
        * if(this.tree != null && disabledOptions != null && disabledOptions.length > 0) {
        *    this.tree.disables = disabledOptions;
        *    
        * }
        */

        this.overrideStyleDisabled();
    }

    private getAllOptions(): String[] {
        let disabledOptions = [];

        this.treeData?.forEach(k => {
            disabledOptions.push(k.id);
        });

        return disabledOptions;
    }

    private overrideStyleDisabled(): void {
        let nodeList = this.view.querySelectorAll(".treejs .treejs-node__disabled");

        if (nodeList != null) {
            for (let i = 0; nodeList[i]; i++) {
                (nodeList[i] as HTMLElement).style.cursor = 'context-menu';
                (nodeList[i] as HTMLElement).style.color = 'black';
            }
        }
        nodeList = this.view.querySelectorAll(".treejs .treejs-node__disabled .treejs-checkbox");
        if (nodeList != null) {
            for (let i = 0; nodeList[i]; i++) {
                (nodeList[i] as HTMLElement).style.cursor = 'pointer';
            }
        }
    }

    public addOptions(options: FieldOptions): void {
        if (options == null) {
            return;
        }
        for (const option of options) {
            if (isOption(option)) {
                this.treeData.push(
                    {
                        id: option.value,
                        text: this.getText(option),
                        disabled: option.disabled,
                    },
                );
            }
            if (isOptgroup(option)) {
                const node = {
                    id: this.generateId(),
                    text: this.getText(option),
                    disabled: option.disabled,
                };
                this.addOptionsToParent(option.options, node);
                this.treeData.push(node);
            }
        }
    }

    private getText(option: Option | Optgroup): string {
        let text;
        if (option["message"] != null) {
            text = i18n.instance.t(option["message"].key, option["message"].args);
        } else if (option["labelKey"] != null) {
            text = i18n.instance.t(option["labelKey"]);
        } else {
            text = option.text;
        }
        return text;
    }

    private addOptionsToParent(options: FieldOptions, parent: TreeData) {
        for (const option of options) {
            parent.children = parent.children || [];
            if (isOption(option)) {
                parent.children.push(
                    {
                        id: option.value,
                        text: this.getText(option),
                        disabled: option.disabled,
                    },
                );
            }
            if (isOptgroup(option)) {
                const node = {
                    id: this.generateId(),
                    text: this.getText(option),
                    disabled: option.disabled,
                };
                this.addOptionsToParent(option.options, node);
                parent.children.push(node);
            }
        }
    }

    public setReadOnly(ro: boolean): void {
        throw new Error("Method not implemented.");
    }
    public setRequired(required: boolean): void {
        throw new Error("Method not implemented.");
    }

    public setValidationStatus(required: boolean): void {
        // throw new Error("Method not implemented.");
    }
}

export interface TreeDefinition extends ValueComponentDefinition {
    options?: Array<Option | Optgroup>;
    closeDepth?: number;
}

interface TreeData {
    id: string | number;
    text: string;
    disabled: boolean;
    children?: TreeData[];
}
